'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactOcticons = require('react-octicons');

require('./GithubRepo.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emojiJs = require('emoji-js');

var GithubRepo = function (_Component) {
  _inherits(GithubRepo, _Component);

  function GithubRepo() {
    _classCallCheck(this, GithubRepo);

    var _this = _possibleConstructorReturn(this, (GithubRepo.__proto__ || Object.getPrototypeOf(GithubRepo)).call(this));

    _this.state = {
      isLoading: true,
      repo: {},
      user: {},
      lastRelease: {
        name: '',
        zipUrl: '',
        tarUrl: ''
      }
    };

    _this.closing = false;
    return _this;
  }

  _createClass(GithubRepo, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var emoji = new emojiJs.EmojiConvertor();
      // convert colons to unicode
      emoji.init_env();
      emoji.replace_mode = 'unified';
      emoji.allow_native = true;
      // show the short-name as a `title` attribute for css/img emoji
      emoji.include_title = true;
      // Configure this library to use the sheets defined in `img_sets`
      emoji.use_sheet = true;
      // img_set
      emoji.img_set = 'emojione';

      if (this.props.objRepo) {
        var description = this.props.objRepo.description || '';
        description = this.truncate(description);
        description = emoji.replace_colons(description);

        this.props.objRepo.description = description;

        this.setState({
          isLoading: false,
          repo: this.props.objRepo || {},
          user: this.props.objRepo.owner || {}
        });
      } else {
        window.fetch('https://api.github.com/repos/' + this.props.user + '/' + this.props.repo).then(function (response) {
          return response.json();
        }).then(function (json) {
          if (_this2.closing) {
            return;
          }

          var description = json.description || '';
          description = _this2.truncate(description);
          description = emoji.replace_colons(description);

          json.description = description;

          _this2.setState({
            isLoading: false,
            repo: json || {},
            user: json.owner || {}
          });
        }).catch(function (ex) {
          _this2.setState({
            isLoading: false
          });
          throw ex;
        });

        // retrieve last release
        window.fetch('https://api.github.com/repos/' + this.props.user + '/' + this.props.repo + '/releases').then(function (response) {
          return response.json();
        }).then(function (json) {
          if (_this2.closing) {
            return;
          }

          if ((typeof json === 'undefined' ? 'undefined' : _typeof(json)) === 'object' && json.length > 0) {
            _this2.setState({
              isLoading: false,
              lastRelease: {
                name: json[0].name,
                tarUrl: json[0].tarball_url,
                zipUrl: json[0].zipball_url,
                date: json[0].published_at
              }
            });
          }
        }).catch(function (ex) {
          _this2.setState({
            isLoading: false
          });
          throw ex;
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.objRepo) {
        var emoji = new emojiJs.EmojiConvertor();
        // convert colons to unicode
        emoji.init_env();
        emoji.replace_mode = 'unified';
        emoji.allow_native = true;
        // show the short-name as a `title` attribute for css/img emoji
        emoji.include_title = true;
        // Configure this library to use the sheets defined in `img_sets`
        emoji.use_sheet = true;
        // img_set
        emoji.img_set = 'emojione';

        var description = props.objRepo.description || '';
        description = this.truncate(description);
        description = emoji.replace_colons(description);

        props.objRepo.description = description;

        this.setState({
          repo: props.objRepo || {},
          user: props.objRepo.owner || {}
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.closing = true;
    }
  }, {
    key: 'truncate',
    value: function truncate(str, length, ending) {
      var strLength = 0,
          maxLength = 120,
          strEnding = '...';

      if (str !== undefined) {
        strLength = str.length;
      }

      if (length !== undefined) {
        maxLength = length;
      }

      if (ending !== undefined) {
        strEnding = ending;
      }

      if (strLength > maxLength) {
        return str.substring(0, maxLength - strEnding.length) + strEnding;
      } else {
        return str;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var avatar = _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_reactOcticons.OctofaceIcon, { className: 'rsg-loading-icon' })
      );
      var classes = "rsg-github-wrapper rsg-github-repo";

      if (this.state.user.avatar_url !== undefined) {
        avatar = _react2.default.createElement('img', {
          alt: this.state.user.login || '',
          className: 'rsg-avatar',
          src: this.state.user.avatar_url || ''
        });
      } else {
        classes = "rsg-github-is-loading";
      }

      return _react2.default.createElement(
        'div',
        { className: classes },
        avatar,
        _react2.default.createElement(
          'span',
          { className: 'rsg-name' },
          this.state.repo.full_name
        ),
        _react2.default.createElement(
          'span',
          { className: 'rsg-info rsg-info--secondary' },
          this.state.repo.language
        ),
        _react2.default.createElement(
          'p',
          { className: 'rsg-info rsg-info--italic' },
          this.state.repo.description
        ),
        _react2.default.createElement(
          'div',
          { className: 'rsg-counters' },
          _react2.default.createElement(
            'div',
            { className: 'rsg-item' },
            _react2.default.createElement(
              'div',
              { className: 'rsg-icon' },
              _react2.default.createElement(_reactOcticons.StarIcon, null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'rsg-description' },
              _react2.default.createElement(
                'div',
                { className: 'rsg-count' },
                Number(this.state.repo.stargazers_count || 0).toLocaleString()
              ),
              _react2.default.createElement(
                'div',
                { className: 'rsg-label' },
                this.state.repo.stargazers_count > 1 ? "Stars" : "Star"
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'rsg-item' },
            _react2.default.createElement(
              'div',
              { className: 'rsg-icon' },
              _react2.default.createElement(_reactOcticons.RepoForkedIcon, null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'rsg-description' },
              _react2.default.createElement(
                'div',
                { className: 'rsg-count' },
                Number(this.state.repo.forks || 0).toLocaleString()
              ),
              _react2.default.createElement(
                'div',
                { className: 'rsg-label' },
                this.state.repo.forks > 1 ? "Forks" : "Fork"
              )
            )
          )
        ),
        _react2.default.createElement(
          'a',
          {
            className: 'rsg-btn rsg-btn-github',
            href: "https://github.com/" + this.state.repo.full_name,
            target: '_blank'
          },
          _react2.default.createElement(_reactOcticons.RepoIcon, { className: 'rsg-icon' }),
          _react2.default.createElement(
            'span',
            { className: 'rsg-text' },
            'View Repository'
          )
        )
      );
    }
  }]);

  return GithubRepo;
}(_react.Component);

GithubRepo.propTypes = {
  // objRepo
  objRepo: _propTypes2.default.object,

  // repo
  repo: _propTypes2.default.string,

  // user
  user: _propTypes2.default.string
};

exports.default = GithubRepo;